import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import LandingPage from "./pages/LandingPage";
import MapPage from "./pages/MapPage";
import AdoptPage from "./pages/AdoptPage";
import AdoptSuccessPage from "./pages/AdoptSuccessPage";
import MyForestPage from "./pages/MyForestPage";
import TransparencyPage from "./pages/TransparencyPage";
import TreeDetailPage from "./pages/TreeDetailPage";
import AdminPage from "./pages/AdminPage";
import CommunityPage from "./pages/CommunityPage";
import EducationPage from "./pages/EducationPage";
import GovernancePage from "./pages/GovernancePage";
import VisionPage from "./pages/VisionPage";
import DonationCategoryPage from "./pages/DonationCategoryPage";
import CommunityMemoriaPage from "./pages/CommunityMemoriaPage";
import MarketplacePage from "./pages/MarketplacePage";
import ZoneDetailPage from "./pages/ZoneDetailPage";
import WorkerLoginPage from "./pages/WorkerLoginPage";
import WorkerDashboardPage from "./pages/WorkerDashboardPage";
import ProofUploadPage from "./pages/ProofUploadPage";
import BiosphereParkPage from "./pages/BiosphereParkPage";
import AuthCallback from "./pages/AuthCallback";

import "./App.css";

function AppRouter() {
  const location = useLocation();
  
  // Check for session_id in URL fragment (OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/map" element={<MapPage />} />
      <Route path="/adopt" element={<AdoptPage />} />
      <Route path="/adopt/success" element={<AdoptSuccessPage />} />
      <Route path="/my-forest" element={<MyForestPage />} />
      <Route path="/transparency" element={<TransparencyPage />} />
      <Route path="/tree/:treeId" element={<TreeDetailPage />} />
      <Route path="/community" element={<CommunityPage />} />
      <Route path="/education" element={<EducationPage />} />
      <Route path="/governance" element={<GovernancePage />} />
      <Route path="/vision" element={<VisionPage />} />
      <Route path="/donate/:category" element={<DonationCategoryPage />} />
      <Route path="/community/memoria" element={<CommunityMemoriaPage />} />
      <Route path="/marketplace" element={<MarketplacePage />} />
      <Route path="/marketplace/zone/:zoneId" element={<ZoneDetailPage />} />
      <Route path="/biosphere" element={<BiosphereParkPage />} />
      <Route path="/worker/login" element={<WorkerLoginPage />} />
      <Route path="/worker/verify" element={<WorkerLoginPage />} />
      <Route path="/worker/dashboard" element={<WorkerDashboardPage />} />
      <Route path="/worker/upload-proof/:token" element={<ProofUploadPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App min-h-screen bg-background">
            <AppRouter />
            <Toaster position="top-right" richColors />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
